<div class="timecounter">
  @if (this.diffInSeconds() > 0) {
  <div>Zeit zum Bezahlung</div>
  <div class="counter">
    <span id="hours">{{ currentTimer().hoursToDay | padnumber }}</span>
    <span id="minutes">{{ currentTimer().minutesToDay | padnumber }}</span>
    <span id="seconds">{{ currentTimer().secondsToDay | padnumber }}</span>
  </div>
  } @else { Zeitfenster für das Bezahlen ist abgelaufen. }
</div>
